(function () {
  'use strict';

  angular.module('app').component('invoiceChangeStatus', invoiceChangeStatus());

  function invoiceChangeStatus() {
    return {
      bindings: {
        invoice: '=',
        changeHeaderColor: '&',
        onInvoiceStatusChanged: '&',
      },
      controller: InvoiceChangeStatus,
      controllerAs: 'vm',
      templateUrl: './app/ajs/invoices/invoice-change-status/invoice-change-status.component.html',
    };
  }

  InvoiceChangeStatus.$inject = ['UtilService', 'InvoiceService'];

  function InvoiceChangeStatus(UtilService, InvoiceService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.canDue = false;
    vm.canOverdue = false;
    vm.canUnpaid = false;
    vm.canPaid = false;

    // Methods
    vm.changeStatusTo = changeStatusTo;
    vm.changeStatus = changeStatus;

    vm.$onInit = function () {
      if (vm.invoice.status === 'due') {
        vm.canOverdue = true;
        vm.canUnpaid = true;
        vm.canPaid = true;
      } else if (vm.invoice.status === 'unpaid') {
        vm.canDue = true;
        vm.canOverdue = true;
        vm.canPaid = true;
      } else if (vm.invoice.status === 'overdue') {
        vm.canDue = true;
        vm.canUnpaid = true;
        vm.canPaid = true;
      } else if (vm.invoice.status === 'paid') {
        vm.canDue = true;
        vm.canOverdue = true;
        vm.canUnpaid = true;
      } else {
        vm.canDue = true;
        vm.canOverdue = true;
        vm.canUnpaid = true;
        vm.canPaid = true;
      }
    };

    function changeStatusTo(canChange, option) {
      if (canChange) {
        vm.changingStatus = true;
        vm.option = option;

        if (option === 'due') {
          vm.changeHeaderColor({ option: 'warning' });
          vm.btnColor = 'warning';
        } else if (option === 'overdue') {
          vm.changeHeaderColor({ option: 'danger' });
          vm.btnColor = 'danger';
        } else if (option === 'unpaid') {
          vm.changeHeaderColor({ option: 'danger' });
          vm.btnColor = 'danger';
        } else if (option === 'paid') {
          vm.changeHeaderColor({ option: 'success' });
          vm.btnColor = 'success';
        }
      }
    }

    // change the invoice status and fetchResult
    function changeStatus() {
      vm.invoice.status = vm.option;
      InvoiceService.saveInvoice(vm.invoice).then(function () {
        vm.onInvoiceStatusChanged();
      });
    }
  }
})();
